export function request(sec) {
    return {
        type: 'UPDATE_BANNER_SLIDE_TIME_REQUEST',
        sec
    };
}

export function error(errors) {
    return {
        type: 'UPDATE_BANNER_SLIDE_TIME_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'UPDATE_BANNER_SLIDE_TIME_FINISH',
        data
    };
}
